import API, { handleRequest } from '@/api/lib/api'

// GET: Fetch online order invoice settings for a restaurant
export const getOnlineOrderInvoiceSettingsApi = restaurantId =>
  handleRequest(() =>
    API.get(`online-order/settings/restaurant/${restaurantId}/invoice`)
  )

// PUT: Update online order invoice settings for a restaurant
export const updateOnlineOrderInvoiceSettingsApi = (restaurantId, data) =>
  handleRequest(() =>
    API.put(
      `online-order/settings/restaurant/${restaurantId}/online-order-invoices/${data.invoiceId}/summary`,
      data
    )
  )

// GET: Fetch online order invoice calendar for a restaurant by year
export const getOnlineOrderCalendarApi = (restaurantId, year) =>
  handleRequest(() =>
    API.get(
      `online-order/settings/restaurant/${restaurantId}/online-order-invoices/calendar`,
      {
        params: { year }
      }
    )
  )

// GET: Fetch online order invoice summary by invoice ID
export const getOnlineOrderInvoiceSummaryApi = (restaurantId, invoiceId) =>
  handleRequest(() =>
    API.get(
      `online-order/settings/restaurant/${restaurantId}/online-order-invoices/${invoiceId}/summary`
    )
  )

// GET: Fetch single online order invoice details
export const getOnlineOrderInvoiceApi = (restaurantId, invoiceId) =>
  handleRequest(() =>
    API.get(
      `online-order/settings/restaurant/${restaurantId}/online-order-invoices/${invoiceId}`
    )
  )

// GET: Fetch account statement for an online order invoice
export const getOnlineOrderAccountStatementApi = (restaurantId, invoiceId) =>
  handleRequest(() =>
    API.get(
      `online-order/settings/restaurant/${restaurantId}/online-order-invoices/${invoiceId}/account-statement`
    )
  )

// GET: Fetch orders list for an online order invoice (with pagination & search)
export const getOnlineOrderOrdersApi = (restaurantId, invoiceId, params = {}) =>
  handleRequest(() =>
    API.get(
      `online-order/settings/restaurant/${restaurantId}/online-order-invoices/${invoiceId}/orders`,
      {
        params: {
          per_page: params?.per_page ?? 10,
          search: params?.search ?? '',
          page: params?.page ?? 1
        }
      }
    )
  )

// GET: Fetch general invoice settings (bank details, etc.)
export const getInvoiceSettingsApi = restaurantId =>
  handleRequest(() =>
    API.get(`online-order/settings/restaurant/${restaurantId}/invoice`)
  )
